export default "__VITE_ASSET__UubVEI_j__"